<template>
  <el-dialog
    width="80%"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="不具合No選択"
    top="5vh"
    :visible.sync="dialogVisible"
    append-to-body
    @close="close"
  >
    <vab-table
      ref="table"
      api-url="/api/mprbnop/foundData"
      :columns="columns"
      :custom-config="false"
      :init-params="{
        inlstbr1cd: actionRow.inspectionList1Cd,
        inlstbr2cd: actionRow.inspectionList2Cd,
        inlstbr3cd: actionRow.inspectionList3Cd,
      }"
      @selection-change="setSelectRows"
    >
      <template #criterion="{ row }">
        <p>{{ row.prbjdgstd1 }}</p>
        <p>{{ row.prbjdgstd2 }}</p>
        <p>{{ row.prbjdgstd3 }}</p>
        <p>{{ row.prbjdgstd4 }}</p>
        <p>{{ row.prbjdgstd5 }}</p>
        <p>{{ row.prbjdgstd6 }}</p>
      </template>
    </vab-table>
    <div class="mg12 flex_end">
      <vab-button :btn-list="btnList" />
    </div>
  </el-dialog>
</template>

<script>
  import mixDialog from '@/utils/mixDialog'

  export default {
    name: 'ErrorSelect',
    mixins: [mixDialog],
    data() {
      return {
        actionIndex: null,
        selectRows: null,
        actionRow: {},
        tableData: [],
        btnList: [
          {
            name: 'キャンセル',
            type: 'button',
            widht: '104',
            bg: '#ffffff',
            hover: '#ffffff',
            defaultColor: '#848484',
            hidden: false,
            click: () => {
              this.dialogVisible = false
            },
          },
          {
            name: '確定',
            icon: 'answer',
            type: 'button',
            widht: '144',
            hidden: false,
            click: () => {
              this.$emit(
                'handledefectNoChoose',
                this.selectRows,
                this.actionIndex,
                this.actionRow,
                this.actionSonIndex
              )
            },
          },
        ],
        columns: [
          {
            label: '不具合No',
            'min-width': 120,
            prop: 'prbno',
            formatter: (row) => {
              return row.prbno.substring(0, 2) + '-' + row.prbno.substring(2, 3)
            },
          },
          {
            label: '判定基準',
            'min-width': 120,
            prop: 'location',
            slotScope: 'criterion',
            sortable: false,
          },
        ],
      }
    },

    methods: {
      getRow(row, index, sonIndex) {
        this.actionIndex = index
        this.actionSonIndex = sonIndex
        this.actionRow = row
        this.$nextTick(() => {
          this.$refs.table.paramsChange()
        })
      },
      setSelectRows(val) {
        this.selectRows = val
      },
    },
  }
</script>

<style lang="scss" scoped></style>
